<script>
import { getSiteInspection } from '@/utils/site-inspection'

export default {

    data() {
        return {
            loading: false,
            data: null
        }
    },

    methods: {

        async open(id) {
            this.data = null
            this.loading = true

            try {
                const res = await getSiteInspection(id)
                this.data = res?.data?.data || null
            } catch (error) {
                this.$swalToast(error.message, 'error')
            } finally {
                this.loading = false
            }
        },

        statusBadge(status) {
            const map = {
                pending: { label: 'Pending', bg: '#fef3c7', color: '#f59e0b' },
                documents_uploaded: { label: 'Docs Uploaded', bg: '#dbeafe', color: '#3b82f6' },
                completed: { label: 'Completed', bg: '#dcfce7', color: '#22c55e' }
            }
            return map[status] || { label: status, bg: '#f1f5f9', color: '#475569' }
        },

        fileIcon(type) {
            if (type?.includes('pdf')) return 'ti ti-file-type-pdf'
            if (type?.includes('image')) return 'ti ti-photo'
            return 'ti ti-file'
        },

        fileColor(type) {
            if (type?.includes('pdf')) return '#ef4444'
            if (type?.includes('image')) return '#3b82f6'
            return '#64748b'
        }
    }
}
</script>

<template>
    <div class="modal fade" id="site_inspection_detail_modal">
        <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
            <div class="modal-content" style="border:none;border-radius:16px;overflow:hidden;">

                <!-- Header -->
                <div class="modal-header" style="background:linear-gradient(135deg,#0f172a,#1e3a5f);padding:15px 20px;border:none;">
                    <div>
                        <h5 style="font-size:14px;font-weight:700;color:#fff;margin:0;">
                            {{ data?.inspection_number || 'Site Inspection Detail' }}
                        </h5>
                        <div style="font-size:11px;color:#94a3b8;margin-top:2px;">
                            View inspection details, documents & activity
                        </div>
                    </div>
                    <button class="btn-close" data-bs-dismiss="modal" style="filter:invert(1);opacity:.6;"></button>
                </div>

                <!-- Body -->
                <div class="modal-body" style="padding:20px;">

                    <!-- Loading -->
                    <div v-if="loading" class="text-center py-5">
                        <div class="spinner-border text-primary" role="status"></div>
                        <p class="mt-2" style="color:#94a3b8;font-size:12px;">Loading...</p>
                    </div>

                    <template v-else-if="data">

                        <!-- Info Cards -->
                        <div class="row g-3 mb-4">
                            <div class="col-6 col-md-3">
                                <div style="background:#f8fafc;border-radius:10px;padding:12px;text-align:center;">
                                    <div style="font-size:10px;font-weight:600;color:#64748b;margin-bottom:4px;">Status</div>
                                    <span style="font-size:11px;font-weight:600;padding:3px 10px;border-radius:20px;"
                                        :style="{ background: statusBadge(data.status).bg, color: statusBadge(data.status).color }">
                                        {{ statusBadge(data.status).label }}
                                    </span>
                                </div>
                            </div>
                            <div class="col-6 col-md-3">
                                <div style="background:#f8fafc;border-radius:10px;padding:12px;text-align:center;">
                                    <div style="font-size:10px;font-weight:600;color:#64748b;margin-bottom:4px;">Party</div>
                                    <div style="font-size:12px;font-weight:700;color:#0f172a;">{{ data.party?.name }}</div>
                                    <div style="font-size:10px;color:#94a3b8;">{{ data.party?.mobile }}</div>
                                </div>
                            </div>
                            <div class="col-6 col-md-3">
                                <div style="background:#f8fafc;border-radius:10px;padding:12px;text-align:center;">
                                    <div style="font-size:10px;font-weight:600;color:#64748b;margin-bottom:4px;">Inspector</div>
                                    <div style="font-size:12px;font-weight:700;color:#0f172a;">
                                        {{ data.site_inspector?.user?.name || 'Not Assigned' }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 col-md-3">
                                <div style="background:#f8fafc;border-radius:10px;padding:12px;text-align:center;">
                                    <div style="font-size:10px;font-weight:600;color:#64748b;margin-bottom:4px;">Created By</div>
                                    <div style="font-size:12px;font-weight:700;color:#0f172a;">{{ data.created_by?.name }}</div>
                                    <div style="font-size:10px;color:#94a3b8;">{{ $formatDate(data.created_at) }}</div>
                                </div>
                            </div>
                        </div>

                        <!-- Documents -->
                        <div class="mb-4">
                            <h6 style="font-size:12px;font-weight:700;color:#0f172a;margin-bottom:10px;">
                                <i class="ti ti-files me-1" style="color:#3b82f6;"></i>
                                Documents ({{ data.documents?.length || 0 }})
                            </h6>

                            <div v-if="data.documents?.length">
                                <div v-for="doc in data.documents" :key="doc.id"
                                    class="d-flex align-items-center gap-3 p-2 mb-2"
                                    style="background:#f8fafc;border:1px solid #e2e8f0;border-radius:10px;">

                                    <div style="width:36px;height:36px;border-radius:8px;display:flex;align-items:center;justify-content:center;"
                                        :style="{ background: fileColor(doc.type) + '15' }">
                                        <i :class="fileIcon(doc.type)" :style="{ color: fileColor(doc.type), fontSize: '16px' }"></i>
                                    </div>

                                    <div class="flex-grow-1">
                                        <div style="font-size:12px;font-weight:600;color:#0f172a;">{{ doc.name }}</div>
                                        <div style="font-size:10px;color:#94a3b8;">
                                            {{ $formatDate(doc.created_at) }}
                                            <span v-if="doc.uploaded_by"> • Uploaded by {{ doc.uploaded_by.name }}</span>
                                        </div>
                                    </div>


                                    <a :href="doc.document_url" target="_blank"
                                        style="font-size:11px;font-weight:600;color:#3b82f6;text-decoration:none;display:flex;align-items:center;gap:4px;">
                                        <i class="ti ti-external-link" style="font-size:13px;"></i> View
                                    </a>
                                </div>
                            </div>

                            <div v-else style="text-align:center;padding:20px;color:#94a3b8;font-size:12px;">
                                <i class="ti ti-file-off" style="font-size:24px;display:block;margin-bottom:6px;opacity:.4;"></i>
                                No documents uploaded yet.
                            </div>
                        </div>

                        <!-- Activity Timeline -->
                        <div>
                            <h6 style="font-size:12px;font-weight:700;color:#0f172a;margin-bottom:10px;">
                                <i class="ti ti-history me-1" style="color:#f59e0b;"></i>
                                Activity Timeline
                            </h6>

                            <div v-if="data.activities?.length">
                                <div v-for="activity in data.activities" :key="activity.id"
                                    class="d-flex align-items-start gap-3 mb-2 p-2"
                                    style="border-bottom:1px dashed #f1f5f9;">

                                    <div style="width:30px;height:30px;background:#fffbeb;border-radius:8px;display:flex;align-items:center;justify-content:center;flex-shrink:0;">
                                        <i class="ti ti-circle-dot" style="color:#f59e0b;font-size:12px;"></i>
                                    </div>

                                    <div>
                                        <p style="margin:0 0 2px;font-size:12px;color:#1e293b;" v-html="activity.description"></p>
                                        <p style="margin:0;font-size:10px;color:#94a3b8;">
                                            <i class="ti ti-clock-hour-3" style="margin-right:3px;"></i>
                                            {{ $formatDate(activity.created_at, 'DD MMM YYYY, hh:mm a') }}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div v-else style="text-align:center;padding:20px;color:#94a3b8;font-size:12px;">
                                <i class="ti ti-history" style="font-size:24px;display:block;margin-bottom:6px;opacity:.4;"></i>
                                No activity recorded yet.
                            </div>
                        </div>

                    </template>

                </div>

            </div>
        </div>
    </div>
</template>